// NOTE: Navigator
import appNavigator from './modules/navigator/app_navigator.js';
import homeNavigator from './modules/navigator/home_navigator.js';

// NOTE: map contents
// NOTE: Modles
import user          from './map/models/user.js';
import area          from './map/models/area.js';
import searchResult from './map/models/search_result.js';

// NOTE: Views
import dialog                      from './map/views/dialog.js';
import current                     from './map/views/current.js';

// TODO: 移動予定
import map from './map/data/map.js';
import destinationList from './map/views/destination_list.js';
import destinationDetail from './map/views/destination_detail.js';
import heatmap from './map/data/heatmap.js';
import contours from './map/data/contours.js';


export default {
  modules: {
    // NOTE: Navigator
    appNavigator,
    homeNavigator,

    // NOTE: Models
    user,
    area,
    searchResult,

    // NOTE: Views
    dialog,
    current,

    // TODO: 移動予定
    map,
    destinationList,
    destinationDetail,
    heatmap,
    contours,
  },
};



// WEBPACK FOOTER //
// ./src/stores/index.js